import { render } from "./DisinfectRoom.vue?vue&type=template&id=4b6d7ff2&scoped=true"
import script from "./DisinfectRoom.vue?vue&type=script&lang=js"
export * from "./DisinfectRoom.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4b6d7ff2"

export default script